export enum StripeFormField {
  Name = 'name',
  Email = 'email',
  Address = 'address',
  Zipcode = 'zipcode',
  City = 'city',
  PromotionCode = 'promotionCode'
}
